import React, { JSX, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { DropdownImperativeProps, DropdownWrapper } from './DropdownWrapper';
import './Dropdown.scss';

export enum DropdownTheme {
  FLAT = 'FLAT',
  SMALL = 'SMALL',
  PLAIN = 'PLAIN',
  REGULAR = 'REGULAR',
  FULL = 'FULL'
}

interface DropDownProps {
  isOpen?: boolean;
  title?: string;
  children?: Array<JSX.Element> | JSX.Element;
  header: JSX.Element;
  footer?: JSX.Element;
  direction?: 'left' | 'right';
  theme?: DropdownTheme;
  disabled?: boolean;
  showHeader?: boolean;
  callback?(status: boolean): void;
}

const Dropdown: React.FC<DropDownProps> = props => {
  const {
    isOpen,
    title,
    header,
    footer,
    direction = 'right',
    disabled,
    theme,
    children,
    showHeader = false,
    callback = () => true
  } = props;

  const [ dropDownStatus, setDropDownStatus ] = useState(false);
  // tslint:disable-next-line:no-null-keyword
  const dropDownRef = useRef(null);
  // tslint:disable-next-line:no-null-keyword
  const dropDownWrapperRef = useRef<DropdownImperativeProps>(null);

  const isMobile = useMediaQuery(
    { maxWidth: 1024 }
  );

  const dropDownClick = status => {
    if (disabled && status) {
      return;
    }

    status
    ? addBodyClassForMobile()
    : removeBodyClass();

    setDropDownStatus(status);
    if (typeof callback === 'function') {
      callback(status);
    }
  };

  // Function to add the class to the body for mobile devices
  const addBodyClassForMobile = () => {
    isMobile && document.body.classList.add('modal-body--open');
  };

  // Function to remove the class from the body
  const removeBodyClass = () => {
    document.body.classList.remove('modal-body--open');
  };

  // In order for the developer to be able to forcibly close the dropdown from outside,
  // you can use this property "isOpen". Thus, when "isOpen" changes its value to "false",
  // Dropdown component will change to "false" the drop-down status as well.
  useEffect(() => {
    if (!isOpen) {
      setDropDownStatus(false);
      dropDownWrapperRef.current.close();

      return;
    }

    // Clean up by removing the class when the component unmounts
    return () => {
      removeBodyClass();
    };
  }, [isOpen]);

  return (
    <div styleName={classNames('user-dropdown__container', { disabled })}>
      <DropdownWrapper dropDownRef={dropDownRef} onStatusChanged={dropDownClick} ref={dropDownWrapperRef}>
        {header}
      </DropdownWrapper>

      <div styleName={
        classNames({
          'user-dropdown__content': true,
          'user-dropdown__content--top-margin': showHeader,
          'user-dropdown__content--left': direction === 'left',
          open: isOpen || dropDownStatus
        })
      }
           ref={dropDownRef}
      >
        <div styleName={
               classNames({
                 'user-dropdown-menu': true,
                 'user-dropdown-menu--plain': theme === DropdownTheme.PLAIN,
                 'user-dropdown-menu--small': theme === DropdownTheme.SMALL,
                 'user-dropdown-menu--full': theme === DropdownTheme.FULL
               })
             }
             className={
          classNames({
            'user-dropdown-menu--flat': theme === DropdownTheme.FLAT
          })
        }>
          <div styleName="user-dropdown-intro" style={title === undefined ? ({ marginBottom: '0' }) : ({})}>
            <span styleName="user-dropdown-intro__title">
              {title}
            </span>
            <button styleName="user-dropdown-intro__close" type="button" onClick={ () => dropDownClick(!dropDownStatus) }/>
          </div>
          <nav styleName="user-dropdown-nav">
            {children}
          </nav>
          {footer}
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
